module.exports = __webpack_public_path__ + "static/media/list-white.1367876f.png";